import _slicedToArray from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { JsonRpcProvider, Provider } from '@ethersproject/providers';
import { useConfig } from '../../config';
import { ReadonlyNetworksContext } from './context';
import { fromEntries } from '../../../helpers/fromEntries';

var getProviderFromConfig = function getProviderFromConfig(urlOrProviderOrProviderFunction) {
  if (Provider.isProvider(urlOrProviderOrProviderFunction)) {
    return urlOrProviderOrProviderFunction;
  }

  if (typeof urlOrProviderOrProviderFunction === 'function') {
    return urlOrProviderOrProviderFunction();
  }

  return new JsonRpcProvider(urlOrProviderOrProviderFunction);
};

export var getProvidersFromConfig = function getProvidersFromConfig(readOnlyUrls) {
  return fromEntries(Object.entries(readOnlyUrls).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        chainId = _ref2[0],
        urlOrProviderOrProviderFunction = _ref2[1];

    return [chainId, getProviderFromConfig(urlOrProviderOrProviderFunction)];
  }));
};
export function ReadonlyNetworksProvider(_ref3) {
  var _ref3$providerOverrid = _ref3.providerOverrides,
      providerOverrides = _ref3$providerOverrid === void 0 ? {} : _ref3$providerOverrid,
      children = _ref3.children;

  var _useConfig = useConfig(),
      _useConfig$readOnlyUr = _useConfig.readOnlyUrls,
      readOnlyUrls = _useConfig$readOnlyUr === void 0 ? {} : _useConfig$readOnlyUr;

  var _useState = useState(function () {
    return Object.assign(Object.assign({}, getProvidersFromConfig(readOnlyUrls)), providerOverrides);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      providers = _useState2[0],
      setProviders = _useState2[1];

  useEffect(function () {
    setProviders(Object.assign(Object.assign({}, getProvidersFromConfig(readOnlyUrls)), providerOverrides));
  }, Object.entries(readOnlyUrls).flat());
  return _jsx(ReadonlyNetworksContext.Provider, Object.assign({
    value: providers
  }, {
    children: children
  }));
}